
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.083 3.707a7.128 7.128 0 00-4.614-2.094V.938h.687a.469.469 0 000-.938H6.844a.469.469 0 000 .938h.687v.675a7.113 7.113 0 00-3.334 1.072L3.75 2.24a1.14 1.14 0 00-.811-.337c-.307 0-.595.12-.812.337l-.677.679a1.149 1.149 0 000 1.62l.448.45a7.164 7.164 0 00-1.087 3.81c0 1.924.748 3.732 2.105 5.092A7.133 7.133 0 008 16c1.92 0 3.725-.75 5.083-2.11A7.161 7.161 0 0015.187 8.8a7.161 7.161 0 00-2.104-5.092zM2.114 3.58l.678-.679a.208.208 0 01.296 0l.34.34a7.326 7.326 0 00-.973.976l-.34-.341a.21.21 0 010-.296zM8 15.062c-3.446 0-6.25-2.81-6.25-6.263 0-3.454 2.804-6.264 6.25-6.264s6.25 2.81 6.25 6.264-2.804 6.264-6.25 6.264z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 3.413c-2.964 0-5.375 2.416-5.375 5.386S5.036 14.184 8 14.184s5.375-2.416 5.375-5.385c0-2.97-2.411-5.386-5.375-5.386zm.469 9.809v-.548a.469.469 0 00-.938 0v.548a4.45 4.45 0 01-3.944-3.955h.538a.469.469 0 000-.937h-.538a4.45 4.45 0 013.944-3.954v.548a.469.469 0 00.938 0v-.548a4.45 4.45 0 013.944 3.954h-.538a.469.469 0 000 .937h.538a4.45 4.45 0 01-3.944 3.955z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.156 8.528h-.66V6.632a.469.469 0 00-.938 0v2.365c0 .259.21.468.468.468h1.13a.469.469 0 000-.937z","fill":"currentColor"}})])
          )
        }
      }
    